import { Link } from "@magnetic/link";
import { Icon } from "@magnetic/nav";
import { Popover } from "@magnetic/popover";

import {
  getMockShellArrowKeysHelp,
  getMockShellCtrlKeysHelp,
  getMockShellHelp,
  getMockShellMetaKeysHelp
} from "./mockShellUtils";

const commands = getMockShellHelp();
const ctrlCmds = getMockShellCtrlKeysHelp();
const arrowCmds = getMockShellArrowKeysHelp();
const metaCmds = getMockShellMetaKeysHelp();

export const MockShellHelp = () => {
  const renderCommands = (
    cmds: Record<string, string>,
    prefix?: string
  ): React.ReactNode[] => {
    return Object.entries(cmds).map(([cmd, desc]) => (
      <div className="cmd-container" key={cmd}>
        <div className="shell-cmd">
          {prefix && (
            <>
              <span className="cmd">{prefix}</span>+
            </>
          )}
          <span className="cmd">{cmd}</span>
        </div>
        <div className="cmd-desc">{desc}</div>
      </div>
    ));
  };
  return (
    <Popover
      size="lg"
      placement="bottom-end"
      title={
        <>
          {renderCommands(commands)}
          {renderCommands(ctrlCmds, "Ctrl")}
          {renderCommands(arrowCmds)}
          {renderCommands(metaCmds, "Meta")}
        </>
      }
    >
      <Link className="hover-target">
        <Icon kind="help" />
      </Link>
    </Popover>
  );
};
